module.exports = __webpack_public_path__ + "3ec3480cfecfbfa94f6c970746797f8e.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Aside/images/bio-pilar-04.jpg
 ** module id = 369
 ** module chunks = 0
 **/